import React, { Component } from 'react'
import { connect } from 'react-redux'
import DatePicker from "react-datepicker";
import ReactModal from 'react-modal';

import { get } from 'lodash'

class BriefDefect extends Component {
    constructor(props) {
        super(props)

        this.state = {
            coordinates: [],
            title: "",
            description: "",
            deadline: null,
            isDeadlineComplete: false,
            tags: [],
            snagPictures: [],

            showSnagImageModal: false,
            previewSnagPicture: "",
        }
    }

    /// README: SORTING TAGS BY NAME
    compare(a, b) {
        if ('name' in a && 'name' in b) {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
        }
        return 0;
    }

    /// README: FILTER BY TAGS
    filterByTags = (tagMap) => {
        const { tags } = this.state;
        return [...tags].includes(tagMap.tagid);
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (previewSnagPicture) => {
        this.setState({ showSnagImageModal: true, previewSnagPicture, });
    }

    handleCloseModal = () => {
        this.setState({ showSnagImageModal: false });
    }

    componentDidMount() {
        const { selectedMarkerid, floorMarkers } = this.props;
        this.setState({
            ...floorMarkers[selectedMarkerid],
        })
    }

    render() {
        const { formLabelStyle, themeColors, modalStyles, snagDetail, commons} = this.props;
        const {defectMarkers}= commons;

        /// this is placed to pause snagDetail related stuff while snagDetail is not available
        if (!snagDetail) {
            return <React.Fragment />
        }

        const {
            title, description, deadline, isDeadlineComplete, tags, snagPictures,
            previewSnagPicture,
            coordinates,
        } = this.state;
        const descriptionCount = description.length;
        const deadlineToShow = new Date(deadline);

        return (
            <React.Fragment>
                {/* Title and description */}
                <div className="form-group text-left">
                    <label htmlFor="inputText" style={formLabelStyle}>Title</label>
                    <input type="text" className="form-control form-control-sm" id="viewTitle" defaultValue={title} readOnly={true} />
                </div>
                <div className="form-group text-left">
                    <label htmlFor="inputText" style={formLabelStyle}>Description</label>
                    <span className="ml-3" style={{ fontSize: "12px", color: "GrayText" }}>({descriptionCount}/200)</span>
                    <textarea maxLength="200" rows="3" className="form-control form-control-sm" id="viewDescription" defaultValue={description} readOnly={true} />
                </div>
                {/* <div className="form-group text-left">
                    <label htmlFor="inputText" style={formLabelStyle}>Coordinates</label>
                    <input type="text" className="form-control form-control-sm" id="editCoordinates" onChange={this.handleChange} defaultValue={coordinates} readOnly={true}/>
                </div> */}
                <hr />
                {/* Pick a deadline component */}
                <div className="form-group text-left">
                    <label style={formLabelStyle}>Alloted deadline</label>
                    <DatePicker
                        selected={deadlineToShow}
                        dateFormat="MMMM eeee d, yyyy h:mm aa"
                        inline={true}
                        title="Alloted deadline"
                        disabledKeyboardNavigation
                    />
                    <div className="custom-control custom-checkbox mt-3">
                        <input type="checkbox" className="custom-control-input ml-3" id="isViewDeadlineComplete" name="isViewDeadlineCompleteBox" checked={isDeadlineComplete} readOnly={true} />
                        <label className="custom-control-label" htmlFor="isViewDeadlineComplete" style={formLabelStyle}>Task completed?</label>
                    </div>
                </div>
                <hr />
                {/* Tag attach and removal component */}
                <div className="form-group text-left">
                    <label style={formLabelStyle}>All {commons.tagCategories}</label>
                    <span className="badge badge-dark mx-3">{tags.length} {commons.tagCategories} attached</span>
                    <div className="row row-cols mx-3">
                        {'allTagsMap' in snagDetail ? Object.keys(snagDetail.allTagsMap).length > 1 ? Object.values(snagDetail.allTagsMap).sort(this.compare).filter(val => val.tagid !== "elevation").filter(this.filterByTags).map((val, i) => {
                            var pillBackgroundColor = themeColors.themeColor;
                            var pillTextColor = "whitesmoke";
                            return (
                                <div key={val.tagid}>
                                    <span className="badge badge-pill mx-1 px-3" role="button" style={{ backgroundColor: `${pillBackgroundColor}`, color: `${pillTextColor}`, textAlign: "end", fontSize: "12px" }}>{val.name}</span>
                                </div>
                            );
                        }) : `No ${defectMarkers} found` : `No ${defectMarkers} found`}
                    </div>
                </div>
                <hr />
                {/* File upload button */}
                <div className="form-group text-left">
                    <label style={formLabelStyle}>Attached pictures</label>
                    <br />
                    <div className="card p-3">
                        <div className="row row-cols">
                            {snagPictures !== undefined ? snagPictures !== null ? Object.keys(snagPictures).length !== 0 ? Object.values(snagPictures).map((val, i) => (
                                <React.Fragment key={i}>
                                    <img className="px-2" role="button" src={val} alt="" title="View this image" width="60px" onClick={() => { this.handleOpenModal(val) }} />
                                </React.Fragment>
                            )) : <p style={{paddingLeft:'10px'}}>No pictures found</p> : <p style={{paddingLeft:'10px'}}>No pictures found</p> : <p style={{paddingLeft:'10px'}}>No pictures found</p>}
                        </div>
                    </div>
                </div>
                <hr />

                {/* REACT MODALS */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showSnagImageModal}
                    onRequestClose={() => { this.handleCloseModal() }}
                    contentLabel="Snag picture"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal() }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="dynamicModalContainer">
                        <div className="dynamicModalSm" style={{overflowX:'auto'}}>
                    <img src={previewSnagPicture} alt="" title="" height="580px" width="550px" />
                    </div>
                    </div>
                </ReactModal>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        floorMarkers: state.firestore.data.FloorMarkers,
        mut: state.marker,
        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,

        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        commons: state.commons,
    }
}



export default connect(mapStateToProps)(BriefDefect)
